function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import SideBySideTextAndAssetComponentDefaultProps from "segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/default-props";
export default _object_spread_props(_object_spread({}, SideBySideTextAndAssetComponentDefaultProps), {
    fullParagraph: _object_spread_props(_object_spread({}, SideBySideTextAndAssetComponentDefaultProps.fullParagraph), {
        topic: {
            text: "For the creative process",
            color: "brand-blue"
        },
        title: "Streamline your creative workflow",
        body: "Use customizable forms to request all the information needed. Then, easily share assets and receive feedback in real time."
    }),
    asset: _object_spread_props(_object_spread({}, SideBySideTextAndAssetComponentDefaultProps.asset), {
        image: _object_spread_props(_object_spread({}, SideBySideTextAndAssetComponentDefaultProps.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/timeline-view.png"
        })
    })
});
